import styled from '@emotion/styled';

export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
`;
export const FieldCheckBox = styled.label`
	display: flex;
	align-items: center;
	gap: 0.4rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	justify-content: flex-end;
	cursor: pointer;
	input[type='checkbox'] {
		appearance: none; /* 기본 브라우저 스타일 없애기 */
		width: 1.8rem;
		height: 1.8rem;
		border: 2px solid #ced4da;
		border-radius: 0; /* 진짜 사각형 */
		background-color: #fff;
		cursor: pointer;
		position: relative;
		transition: all 0.2s ease;
	}
	input[type='checkbox']:checked {
		background-color: #12539e; /* 체크됐을 때 배경 */
		border-color: #12539e;
	}
	input[type='checkbox']:checked::after {
		content: '';
		position: absolute;
		top: 0px;
		left: 5px;
		width: 4px;
		height: 9px;
		border: solid #fff;
		border-width: 0 2px 2px 0;
		transform: rotate(45deg);
	}
	@media screen and (max-width: 900px) {
		justify-content: flex-start;
	}
`;
export const NextButton = styled.button`
	background-color: ${(props) => props.theme.colors.primary400};
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;
